import * as React from 'react';
import { useEffect } from 'react';
import { BeKindSection } from '../../components/block-be-kind';
import { Footer } from '../../components/footer';
import { InstagramFeed } from '../../components/homepageComponents';
import { Layout } from '../../components/layout';
import { Seo } from '../../components/seo';
import { styled } from '../../styles/stitches.config';

const Shipping = () => {
    // document.getElementsByTagName('body')[0].style.overflow = "auto";
    const ContentContainer = styled('section', {
        padding: '80px 0 80px 0',
        maxWidth: '780px',
        margin: '0 auto',
        '@bp1': {
            paddingLeft: '20px',
            paddingRight: '20px',
        },
        h1: {
            fontFamily: '$default',
            textAlign: 'center',
            fontSize: '36px',
            marginBottom: '56px',
        },
        h2: {
            fontFamily: '$lato',
            fontSize: '18px',
            letterSpacing: '0.1em',
            margin: '0 0 24px 0',
        },
        p: {
            fontFamily: '$lato',
            color: '#585d6c',
            margin: '0 0 24px 0',
            fontSize: '18px',
            lineHeight: '29px',
        }
    });

    return (
        <Layout>
            <Seo
                title={'Shipping and Returns - Better Days Skin Co.'}
            />
            <ContentContainer>
                <h1>Shipping and Returns</h1>
                <h2>COVID-19</h2>
                <p>We&apos;re taking every precaution to keep our team and our customers safe. Please note that there might be slight delays in shipments during this time. We hope you can understand, Thank you for supporting us.</p>

                <h2>SHIPPING POLICY</h2>
                <p><b>Singapore &amp; Hong Kong</b></p>

                <p>We offer free shipping for all orders to Singapore and Hong Kong. You will be sent an email containing the tracking information as soon as it is shipped. Please note that we are closed for deliveries on Saturday, Sunday, and on Public Holidays.</p>

                <p><b>International Shipping</b></p>

                <p>We are currently offering international shipping to a selected number of countries. International customers are responsible for all customs, duties and taxes. International shipping rates are calculated depending on the weight of the package.</p>

                <p>Countries that we are currently shipping to include: Albania, Andorra, Australia, Austria, Bahrain, Bangladesh, Belgium, Bosnia &amp; Herzegovina, Brunei, Bulgaria, Cambodia, Canada, China, Croatia, Cyprus, Denmark, Egypt, Estonia, Faroe Islands, Fiji, Finland, France, Germany, Gibraltar, Greece, Guernsey, Hong Kong SAR China, Hungary, India, Indonesia, Ireland, Israel, Italy, Japan, Jersey, Jordan, Kosovo, Kuwait, Laos, Latvia, Liechtenstein, Lithuania, Luxembourg, Macao SAR China, Malaysia, Maldives, Malta, Mexico, Monaco, Mongolia, Montenegro, Myanmar (Burma), Nepal, Netherlands, New Zealand, North Macedonia, Norway, Oman, Pakistan, Papua New Guinea, Philippines, Poland, Portugal, Qatar, Romania, Saudi Arabia, Serbia, Slovakia, Slovenia, South Africa, South Korea, Spain, Sri Lanka, Sweden, Switzerland, Taiwan, Thailand, Turkey, United Arab Emirates, United Kingdom, United States, Vatican City, Vietnam.</p>

                <p>Please note that we are not responsible for any lost or stolen packages due to the courier/postal service.</p>

                <h2>RETURN POLICY</h2>
                <p>We do not accept any returns at this time.</p>

                <h2>DAMAGES OR WRONG ITEMS</h2>
                <p>Please inspect your order upon reception and contact us immediately at hello@bedaskin.com if the item is defective or damaged. We will evaluate the issue and make it right.</p>

                <h2>CONTACT</h2>
                <p>Questions about the Shipping &amp; Return Policy should be sent to us at hello@bedaskin.com.</p>
            </ContentContainer>
            <BeKindSection />
            <InstagramFeed />
        </Layout>
    )
}

export default Shipping;
